module.exports = __webpack_public_path__ + "static/img/getBtn-disable.9f654e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/getBtn-disable.png
// module id = dVow
// module chunks = 0